/* QMULUS WHOOP-style theme — reveals, data rings, reels, buy */
(function () {
  'use strict';
  document.addEventListener('DOMContentLoaded', init);
  function init() {
    var Q = window.QMULUS || { variantId: null, routes: {} };
    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var desktop = matchMedia('(min-width: 768px)').matches;
    if (typeof window.Lenis === 'function' && !reduce && desktop) {
      var lenis = new window.Lenis({ lerp: 0.12, smoothWheel: true });
      window._qmLenis = lenis;
      requestAnimationFrame(function raf(t){ lenis.raf(t); requestAnimationFrame(raf); });
      document.querySelectorAll('a[data-scroll]').forEach(function (a) { a.addEventListener('click', function (e) { var t = document.querySelector(a.getAttribute('href')); if (t) { e.preventDefault(); lenis.scrollTo(t, { offset: -50 }); } }); });
    }
    // commerce first: bind buy buttons before any decorative code can throw
    function buyNow() { if (!Q.variantId) { location = '/cart'; return; } var qty = window._qmQty || 1;
      var code = qty === 2 ? 'POWERDUO' : qty === 3 ? 'STUDIOTRIO' : '';
      location = '/cart/' + Q.variantId + ':' + qty + (code ? '?discount=' + code : ''); }
    document.querySelectorAll('[data-buynow]').forEach(function (b) { b.addEventListener('click', buyNow); });
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }); }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.r').forEach(function (el) { io.observe(el); });
    // count-up
    var ioc = new IntersectionObserver(function (es) { es.forEach(function (e) { if (!e.isIntersecting) return; var el = e.target, tgt = parseFloat(el.dataset.count), dec = el.dataset.count.indexOf('.') > -1 ? 1 : 0, t0 = null;
      if (reduce) { el.textContent = tgt.toLocaleString(); ioc.unobserve(el); return; }
      function step(ts){ if(t0==null)t0=ts; var p=Math.min((ts-t0)/1300,1),v=1-Math.pow(1-p,3); el.textContent=(tgt*v).toLocaleString(undefined,{minimumFractionDigits:dec,maximumFractionDigits:dec}); if(p<1)requestAnimationFrame(step); }
      requestAnimationFrame(step); ioc.unobserve(el); }); }, { threshold: 0.6 });
    document.querySelectorAll('[data-count]').forEach(function (el) { ioc.observe(el); });
    // data rings
    var ior = new IntersectionObserver(function (es) { es.forEach(function (e) { if (!e.isIntersecting) return; var prog = e.target.querySelector('.prog'); var pct = parseFloat(e.target.dataset.pct || 90); if (prog) prog.style.strokeDashoffset = String(327 * (1 - pct / 100)); ior.unobserve(e.target); }); }, { threshold: 0.5 });
    document.querySelectorAll('.ring').forEach(function (el) { ior.observe(el); });
    // reels hover
    document.querySelectorAll('.reel-card').forEach(function (card) { var v = card.querySelector('video'); if (!v) return;
      card.addEventListener('pointerenter', function () { if (!v.getAttribute('src') && v.dataset.src) v.setAttribute('src', v.dataset.src); card.classList.add('playing'); var p = v.play(); if (p && p.catch) p.catch(function(){}); });
      card.addEventListener('pointerleave', function () { card.classList.remove('playing'); try { v.pause(); v.currentTime = 0; } catch (e) {} }); });
    // reels on touch / no-hover devices: auto-play each clip while it is in view
    if (matchMedia('(hover: none), (max-width: 820px)').matches) {
      var rvio = new IntersectionObserver(function (es) { es.forEach(function (e) {
        var card = e.target, v = card.querySelector('video'); if (!v) return;
        if (e.isIntersecting) { if (!v.getAttribute('src') && v.dataset.src) v.setAttribute('src', v.dataset.src); card.classList.add('playing'); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else { card.classList.remove('playing'); try { v.pause(); } catch (e2) {} }
      }); }, { threshold: 0.5 });
      document.querySelectorAll('.reel-card').forEach(function (card) { if (card.querySelector('video')) rvio.observe(card); });
    }
    // horizontal scroller arrows (desktop)
    document.querySelectorAll('.reels-strip').forEach(function (strip) {
      if (strip.dataset.arrowed) return; strip.dataset.arrowed = '1';
      var wrap = document.createElement('div'); wrap.style.position = 'relative';
      strip.parentNode.insertBefore(wrap, strip); wrap.appendChild(strip);
      function mk(dir) { var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', dir < 0 ? 'Scroll left' : 'Scroll right');
        b.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="' + (dir < 0 ? 'M15 18l-6-6 6-6' : 'M9 18l6-6-6-6') + '"/></svg>';
        b.style.cssText = 'display:none;position:absolute;top:50%;' + (dir < 0 ? 'left:14px' : 'right:14px') + ';transform:translateY(-50%);z-index:7;width:46px;height:46px;border-radius:50%;border:1px solid rgba(0,0,0,.08);background:rgba(255,255,255,.95);color:#111;box-shadow:0 6px 22px rgba(0,0,0,.22);cursor:pointer;align-items:center;justify-content:center;transition:opacity .25s';
        b.addEventListener('click', function () { var t = strip.firstElementChild; var step = t ? t.getBoundingClientRect().width + 16 : 300; strip.scrollBy({ left: dir * step, behavior: 'smooth' }); });
        wrap.appendChild(b); return b; }
      var prev = mk(-1), next = mk(1);
      function upd() { var show = strip.scrollWidth > strip.clientWidth + 8;
        prev.style.display = (show && strip.scrollLeft > 4) ? 'flex' : 'none';
        next.style.display = (show && strip.scrollLeft < strip.scrollWidth - strip.clientWidth - 4) ? 'flex' : 'none'; }
      strip.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); setTimeout(upd, 500);
    });
    // sticky buy bar (homepage hero or PDP buy box)
    var bar = document.getElementById('buybar'), hero = document.getElementById('hero') || document.getElementById('buy');
    if (bar && hero) new IntersectionObserver(function (es) { es.forEach(function (e) { var on = !e.isIntersecting;
      bar.classList.toggle('show', on); document.documentElement.classList.toggle('buybar-on', on); }); }, { rootMargin: '-60px 0px 0px 0px' }).observe(hero);
    // PDP media gallery
    window.pdpImg = function (btn, src) {
      var m = document.getElementById('pdpMain'), v = document.getElementById('pdpVid'); if (!m) return;
      if (v) { try { v.pause(); } catch (e) {} v.style.display = 'none'; v.removeAttribute('src'); }
      m.style.display = ''; m.src = src;
      document.querySelectorAll('.pdp-thumbs button').forEach(function (b) { b.classList.remove('on'); }); btn.classList.add('on');
    };
    window.pdpVid = function (btn, src, poster) {
      var m = document.getElementById('pdpMain'), v = document.getElementById('pdpVid'); if (!v) return;
      if (m) m.style.display = 'none';
      v.style.display = ''; v.controls = true; if (poster) v.poster = poster; v.src = src; var p = v.play(); if (p && p.catch) p.catch(function () {});
      document.querySelectorAll('.pdp-thumbs button').forEach(function (b) { b.classList.remove('on'); }); btn.classList.add('on');
    };
    // savings calculator
    var calc = document.getElementById('calc');
    if (calc) {
      var CUBE = ((Q.price || 29900) / 100);
      function money(n){ return '$' + Math.round(n).toLocaleString(); }
      function recalcSave(){
        var gym = +document.getElementById('cGym').value, com = +document.getElementById('cCom').value;
        var eq = +document.getElementById('cEq').value, yr = +document.getElementById('cYr').value;
        document.getElementById('cGymV').textContent = '$' + gym;
        document.getElementById('cComV').textContent = '$' + com;
        document.getElementById('cEqV').textContent = '$' + eq;
        document.getElementById('cYrV').textContent = yr + ' yrs';
        var pm = gym + com;
        var old = pm * 12 * yr + eq;
        var save = old - CUBE;
        document.getElementById('oPM').textContent = pm > 0 ? money(pm) + '/mo' : '$0/mo';
        document.getElementById('oOld').textContent = money(old);
        document.getElementById('oSave').textContent = save > 0 ? money(save) : '$0';
        document.getElementById('oBreak').textContent = pm > 0 ? (Math.ceil(CUBE / pm * 10) / 10) + ' months' : '–';
      }
      ['cGym','cCom','cEq','cYr'].forEach(function(id){ var el = document.getElementById(id); if (el) el.addEventListener('input', recalcSave); });
      recalcSave();
    }
    // story tabs
    var st = document.getElementById('storyTabs');
    if (st) {
      st.querySelectorAll('button').forEach(function(b){
        b.addEventListener('click', function(){
          st.querySelectorAll('button').forEach(function(x){ x.classList.remove('on'); });
          b.classList.add('on');
          document.querySelectorAll('.wstory').forEach(function(s){ s.classList.toggle('on', s.dataset.s === b.dataset.story); });
        });
      });
    }
    // workout library filter
    var lt = document.getElementById('libTabs');
    if (lt) {
      lt.querySelectorAll('button').forEach(function(b){
        b.addEventListener('click', function(){
          lt.querySelectorAll('button').forEach(function(x){ x.classList.remove('on'); });
          b.classList.add('on');
          var cat = b.dataset.cat;
          document.querySelectorAll('#libGrid .e').forEach(function(e){ e.style.display = (cat === 'all' || e.dataset.cat === cat) ? '' : 'none'; });
        });
      });
    }
    // ship-by countdown (to 3pm CT)
    var sc = document.getElementById('shipCount');
    if (sc) {
      var DAYS = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
      var lead = sc.parentNode;
      function tick(){
        var now = new Date();
        var ct = new Date(now.toLocaleString('en-US', { timeZone: 'America/Chicago' }));
        if (isNaN(ct)) { sc.textContent = '3pm CT'; return; }
        var cut = new Date(ct); cut.setHours(15, 0, 0, 0);
        if (ct > cut) cut.setDate(cut.getDate() + 1);
        while (cut.getDay() === 0 || cut.getDay() === 6) cut.setDate(cut.getDate() + 1);
        var sameDay = cut.toDateString() === ct.toDateString();
        if (lead) lead.firstChild.nodeValue = sameDay ? 'Order by 3pm CT for same-day dispatch. Ships today if ordered in '
                                                      : 'Ships ' + DAYS[cut.getDay()] + '. Order by 3pm CT, in ';
        var d = Math.max(0, cut - ct), h = Math.floor(d / 3.6e6), m = Math.floor(d % 3.6e6 / 6e4), s2 = Math.floor(d % 6e4 / 1e3);
        sc.textContent = h + 'h ' + (m < 10 ? '0' : '') + m + 'm ' + (s2 < 10 ? '0' : '') + s2 + 's';
      }
      tick(); setInterval(tick, 1000);
    }
    // keep the background loops alive. Browsers pause an autoplaying video when
    // the tab is hidden (and iOS does it in Low Power Mode) and several of them
    // never resume it on return, which looks exactly like a video that stopped
    // looping. Only videos with no controls, so a clip the visitor paused by hand
    // is left alone.
    try {
      var bgLoops = document.querySelectorAll('video[autoplay][loop]:not([controls])');
      if (bgLoops.length && !reduce) {
        var kickLoops = function () {
          if (document.visibilityState === 'hidden') return;
          bgLoops.forEach(function (vid) {
            if (vid.paused) { var pr = vid.play(); if (pr && pr.catch) pr.catch(function () {}); }
          });
        };
        document.addEventListener('visibilitychange', kickLoops);
        window.addEventListener('pageshow', kickLoops);
        window.addEventListener('focus', kickLoops);
        bgLoops.forEach(function (vid) { vid.addEventListener('pause', function () { setTimeout(kickLoops, 120); }); });
        kickLoops();
      }
    } catch (e) {}
    // ---- email capture popup ----
    try {
      var pop = document.getElementById('qmnl');
      if (pop) {
        var KEY = 'qm_nl_v1', DISMISS_DAYS = 14;
        var MIN_ON_PAGE = 6000;   // floor for the timer / scroll triggers
        var EXIT_MIN = 2000;      // shorter floor for exit intent: they are leaving now
        var IDLE_MS = 10000;      // show after this long on the page
        var SCROLL_VH = 1.2;      // ...or once they scroll past ~1.2 screens
        var store = {
          get: function () { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } },
          set: function (o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }
        };
        var SKIP = ['/cart', '/checkout', '/account', '/challenge', '/tools', '/password'];
        var path = location.pathname.toLowerCase();
        var blocked = SKIP.some(function (p) { return path === p || path.indexOf(p + '/') === 0; });
        var state = store.get();
        // ?popup=reset clears the remembered dismissal so the triggers can be tested
        // again without hunting for a private window
        if (/[?&]popup=reset(&|$)/.test(location.search)) {
          try { localStorage.removeItem(KEY); } catch (e) {}
          state = {};
        }
        var dismissedRecently = state.d && (Date.now() - state.d) < DISMISS_DAYS * 864e5;
        var posted = pop.querySelector('[data-qmnl-posted]');
        var form = pop.querySelector('form');
        var input = pop.querySelector('.qmnl-in');
        var errEl = pop.querySelector('[data-qmnl-err]');
        var lastFocus = null, shown = false, timer = null;
        var onScroll = null, onExit = null, onLeave = null, onMove = null, pendingOpen = false;
        document.addEventListener('visibilitychange', function () {
          if (pendingOpen && document.visibilityState !== 'hidden') open();
        });

        function focusable() {
          return [].slice.call(pop.querySelectorAll('button,[href],input,select,textarea')).filter(function (el) {
            return !el.disabled && el.offsetParent !== null;
          });
        }
        function open() {
          if (shown) return;
          // Never open while the tab is in the background. requestAnimationFrame is
          // suspended there, so the .on class that drives opacity would never be
          // applied: the popup would un-hide at z-index 1200 and sit over the whole
          // page, invisible but still swallowing every click. Queue it instead and
          // open when the visitor actually comes back.
          if (document.visibilityState === 'hidden') { pendingOpen = true; return; }
          pendingOpen = false; shown = true;
          clearTimeout(timer);
          if (onScroll) window.removeEventListener('scroll', onScroll);
          if (onExit) document.removeEventListener('mouseout', onExit);
          if (onLeave) document.documentElement.removeEventListener('mouseleave', onLeave);
          if (onMove) document.removeEventListener('mousemove', onMove);
          lastFocus = document.activeElement;
          pop.hidden = false; pop.removeAttribute('aria-hidden');
          document.documentElement.classList.add('qmnl-open');
          if (window._qmLenis && window._qmLenis.stop) { try { window._qmLenis.stop(); } catch (e) {} }
          var paint = function () { pop.classList.add('on'); };
          requestAnimationFrame(paint);
          setTimeout(paint, 80); // belt and braces if rAF is throttled
          var first = posted ? pop.querySelector('[data-qmnl-close]') : (input || pop.querySelector('[data-qmnl-close]'));
          if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }, 60);
        }
        function close(remember) {
          if (!shown) return; shown = false;
          pop.classList.remove('on');
          document.documentElement.classList.remove('qmnl-open');
          if (window._qmLenis && window._qmLenis.start) { try { window._qmLenis.start(); } catch (e) {} }
          setTimeout(function () { pop.hidden = true; pop.setAttribute('aria-hidden', 'true'); }, 340);
          var s = store.get();
          if (remember !== false && !s.s) { s.d = Date.now(); store.set(s); }
          if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
        }
        function subscribed() { var s = store.get(); s.s = 1; delete s.d; store.set(s); }

        pop.addEventListener('click', function (e) {
          if (e.target.closest && e.target.closest('[data-qmnl-close]')) { e.preventDefault(); close(); }
        });
        document.addEventListener('keydown', function (e) {
          if (!shown) return;
          if (e.key === 'Escape') { close(); return; }
          if (e.key !== 'Tab') return;
          var f = focusable(); if (!f.length) return;
          var first = f[0], last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        });

        // full-reload success path: Shopify bounced back with the posted form.
        // customer_posted=true is the belt-and-braces case: the visitor cleared
        // Shopify's bot challenge and came back on a render where the form context
        // did not survive, so we still must not nag them again.
        var postedParam = location.search.indexOf('customer_posted=true') > -1;
        // ?popup=1 forces it open regardless of state, for reviewing the design
        var forced = /[?&]popup=1(&|$)/.test(location.search);
        if (posted) { subscribed(); open(); }
        else if (postedParam) { subscribed(); }
        else if (forced) { open(); }
        else if (pop.querySelector('[data-qmnl-force]')) { open(); }
        else if (!blocked && !state.s && !dismissedRecently) {
          var t0 = Date.now();
          // floor defaults to MIN_ON_PAGE; exit intent passes its own shorter one
          var fire = function (floor) {
            var wait = (typeof floor === 'number' ? floor : MIN_ON_PAGE) - (Date.now() - t0);
            if (wait <= 0) open(); else setTimeout(open, wait);
          };
          timer = setTimeout(fire, IDLE_MS);
          // scroll depth in SCREENS, not as a fraction of the page. The homepage is
          // over 20000px tall, so the old "35% of the page" worked out to ~6800px
          // and essentially never fired before the timer did.
          onScroll = function () { if (window.scrollY >= window.innerHeight * SCROLL_VH) fire(); };
          // exit intent: the pointer leaves through the TOP of the window, which is
          // the move towards the tab bar, the close button and the address bar.
          // relatedTarget/toElement are null only when it really left the document.
          // Exit intent. A fast flick towards the tab bar does NOT reliably report
          // clientY near 0 on the event that leaves the document, so keying only on
          // the exit coordinate misses most real exits. Track whether the pointer was
          // travelling upward and accept either signal.
          var lastY = null, movingUp = false;
          onMove = function (e) {
            if (lastY !== null && e.clientY !== lastY) movingUp = e.clientY < lastY;
            lastY = e.clientY;
          };
          var leaving = function (y) {
            if (y <= 60) return true;                                  // left near the top edge
            return movingUp && y <= window.innerHeight * 0.6;          // or heading up and out
          };
          onExit = function (e) {
            if (e.relatedTarget || e.toElement) return;  // moved to another element, still inside
            if (leaving(e.clientY)) fire(EXIT_MIN);
          };
          onLeave = function (e) { if (leaving(e.clientY)) fire(EXIT_MIN); };
          window.addEventListener('scroll', onScroll, { passive: true });
          // any-hover/any-pointer, not hover/pointer: a touchscreen laptop reports a
          // coarse PRIMARY pointer and would have been excluded even with a mouse
          if (matchMedia('(any-hover: hover) and (any-pointer: fine)').matches) {
            document.addEventListener('mousemove', onMove, { passive: true });
            document.addEventListener('mouseout', onExit);
            document.documentElement.addEventListener('mouseleave', onLeave);
          }
        }

        if (form && !posted) {
          // NATIVE submit on purpose. Shopify guards /contact with an invisible bot
          // challenge that is wired to the form's own submit event; an AJAX POST
          // bypasses it and gets bounced to the /challenge page. So we only do
          // client-side validation here and let the browser post the form. Shopify
          // redirects back with ?customer_posted=true and the Liquid branch above
          // re-opens this popup in its success state.
          form.addEventListener('submit', function (e) {
            var v = input ? input.value.trim() : '';
            if (!/^[^@\s]+@[^@\s.]+\.[^@\s]+$/.test(v)) {
              e.preventDefault();
              if (errEl) { errEl.hidden = false; errEl.textContent = 'Please enter a valid email address.'; }
              if (input) input.focus();
              return;
            }
            if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
            var btn = form.querySelector('.qmnl-btn');
            setTimeout(function () { if (btn) { btn.disabled = true; btn.textContent = 'Joining...'; } }, 0);
            // the page is about to navigate; if anything blocks it, put the button back
            setTimeout(function () { if (btn) { btn.disabled = false; btn.textContent = 'Join the list'; } }, 8000);
          });
        }
      }
    } catch (e) { /* never let the popup break the page */ }
    // (buy bindings installed at the top of init)
  }
})();
